import styled from 'styled-components';

export const StyledFormLabelContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledLabel = styled.label`
    font-size: 16px;
    color: var(--color-text-primary);
`;

export const StyledRequiredMark = styled.span`
    font-size: 16px;
    color: var(--color-error);
`;

export const StyledPlaceholder = styled.span`
    /* Empty placeholder for layout purposes */
`;
